/* global angular */
( function () {
	'use strict';

	// TODO: this controller has grown too big, need to refactor this.
	/* eslint-disable max-params */
	function NewTemplates ( $scope, $routeParams, logger, templateservice, $location, collectionService, apiService, $rootScope, deepLoadingStatusService, TOOLTIP_MESSAGES, ERROR_MSGS, templateHolder, manageShareService, authService, templatePdf, revisionModal, templateView, route, Session, ppdFactory ) {
		/* eslint-enable max-params */
		var self        = this;
		var credentials = templateservice.credentialHandler();
		var selected    = [];
		var tempName;

		self.isGenerating      = false;
		self.title             = 'New Template';
		self.bypass            = false;
		self.disableSaveButton = false;
		self.tooltip           = TOOLTIP_MESSAGES;

		/**
		 * Trims leading and trailing spaces for template name
		 */
		function trimTemplateName () {
			if ( typeof self.model.template.name === 'undefined' || self.model.template.name.trim().length === 0 ) {
				self.model.template.name = tempName;
			}

			self.model.template.name = self.model.template.name.trim();
		}

		function initGroupModel () {
			var length = self.model.groups.length + 1;

			return {
				'groupName'  : 'Untitled Section ' + length,
				'indicators' : [ ]
			};
		}

		function addGroupHandler () {
			var newGroupModel = angular.copy( initGroupModel() );

			newGroupModel.id  = apiService.generateUUID();

			collectionService.addModelWithId( self.model.groups, newGroupModel, 'groupId' );
		}

		function shareLoadingStatus () {
			return self.isLoaded;
		}

		function templateAttachmentMapper ( item ) {
			return {
				'ContentName' : item.name || item.ContentName,
				'ContentId'   : item.id || item.ContentId,
				'type'        : item.type || 1
			};
		}

		function initialize ( types, data ) {
			self.model                     = angular.copy( templateservice.load( types, data ) );
			self.model.templateAttachments = ( self.model.templateAttachments || [] ).map( templateAttachmentMapper );
			tempName                       = self.model.template.name;

			self.initData = {
				'types' : types,
				'data'  : data
			};

			ppdFactory.setMasterSource( self.model );

			$rootScope.$broadcast( 'obs:get:groups', self.model.groups, true, addGroupHandler, shareLoadingStatus );

			function tagMapper ( tag ) {
				return {
					'tagName' : tag
				};
			}

			self.model.tags.splice( 0, 0, {
				'filterName' : 'Types',
				'children'   : self.model.types.map( tagMapper )
			} );

			deepLoadingStatusService.incrementLoading( 1, 'group' );

			// triggers the auto-save
			deepLoadingStatusService.decrementLoading();

			templateHolder.setTemplate( self.model );
		}

		/**
		 * get all observation types
		 * used in successCb function
		 * @return {[Object]}      [Observation type]
		 */
		function getTypes ( type ) {
			return type.ObservationTypeName;
		}

		/**
		 * success callback for observation type
		 * and get the types
		 */
		function successCb ( value ) {
			self.types = value.map( getTypes );
		}

		/**
		 * error callback for observation types
		 * sets default or stub data for types
		 */
		function errorCb () {
			self.types = [ 'No Types Available' ];
		}

		function templateErrorCb ( err ) {
			if ( err.status === 403 || err.status === 400 ) {
				logger.notifyErrorPath( '/template/' + $routeParams.id );
				$location.path( '/templates' );
			}
		}

		function successGetTemplate ( data ) {
			// limit the template name display to 140 chars only
			data.name = data.name.substr( 0, 140 );
			templateservice.setMode( 'update' );
			initialize( self.types, data );
		}

		function getFinalizedTemplate ( cb, err ) {
			return function () {
				templateservice
					.getTemplate( credentials.userId, $routeParams.id )
					.then( cb, err );
			};
		}

		function activate () {
			// prevent saving during digest of directives
			self.isLocked        = true;
			self.isValidTemplate = true;

			templateservice.setMode( 'save' );

			if ( $routeParams.id ) {
				templateservice
					.getTemplate( credentials.userId, $routeParams.id, !self.isViewOnlyMode && 'templateDraft' || null )
					.then( successGetTemplate, !self.isViewOnlyMode && getFinalizedTemplate( successGetTemplate, templateErrorCb ) || templateErrorCb );
			} else {
				initialize( self.types );
			}
		}

		function overrideViewMode () {
			templateView.setViewOnly( false );
			route.reload();
		}

		function overridePriv () {
			self.privilege.admin = false;
		}

		function setUserPrivilege ( privileges ) {
			self.privilege = privileges;
			self.origPriv  = angular.copy( privileges );

			( self.isViewOnlyMode && overridePriv || angular.noop )();
		}

		function setDraftFlag ( res ) {
			self.hasDraft = true;
			return res;
		}

		function preActivate () {
			// get template view flag
			self.isViewOnlyMode = templateView.get();

			// prevent auto-save from triggering
			deepLoadingStatusService.initialize( self, 'isLoaded' );

			// check if draft exist if in view mode
			if ( self.isViewOnlyMode ) {
				templateservice
					.getTemplate( credentials.userId, $routeParams.id, 'templateDraft' )
					.then( setDraftFlag, angular.noop );
			}

			// get user privilege with this template
			manageShareService.getPrivilege( $routeParams.id, 'users', credentials.userId, true ).then( setUserPrivilege );

			templateservice
				.observationTypes()
				.then( successCb, errorCb )
				.finally( activate );
		}

		function goBackToList () {
			$location.path( '/templates' );
		}

		function saveTemplate ( formIsInvalid, redirect, type ) {
			if ( self.privilege.admin && !self.isViewOnlyMode ) {
				self.isSaving = 'Saving...';

				if ( !formIsInvalid ) {
					templateservice.save( credentials.userId, self.model, type || 'templateDraft' ).then( function () {
						self.isSaving = 'Saved.';
						if ( self.skipNotify ) {
							logger.notifySuccess( 'Template successfully saved.' );
							self.skipNotify = false;
						}

						templateservice.setMode( 'update' );

						if ( redirect ) {
							$location.path( '/templates' );
							return;
						}

						$scope.$root.$broadcast( 'math:save:close' );

						self.disableSaveButton = false;
					}, function ( err ) {
						self.isSaving          = '';
						self.disableSaveButton = true;

						if ( !self.bypass && ( err.status === 500 || err.status === 403 ) ) {
							templateservice.createNewVersion( err, self.model );
							initialize( self.initData.types, self.initData.data );
							self.bypass = true;
						} else {
							self.bypass = false;
						}

						$scope.$root.$broadcast( 'math:stop:loading' );
					} );
				} else {
					self.isSaving = 'Unable to save.';
					if ( angular.isUndefined( redirect ) ) {
						$scope.$apply();
					}
					$scope.$broadcast( 'show-errors-check-validity' );
					logger.notifyError( ERROR_MSGS.tplCreationFieldsError, '' );
				}
			}
		}

		function closeHandler ( form, type ) {
			self.isLoaded   = false;
			self.skipNotify = true;
			self.overlayMsg = 'Saving Template';
			setTimeout( function () {
				saveTemplate( form, true, type );
			},
			1500 );
		}

		function showHideRevisionModal ( key, model, confirmHandler ) {
			if ( localStorage.getItem( Session.getCredentials().userId + key ) === 'true' ) {
				confirmHandler();
			} else {
				revisionModal.open( model );
			}
		}

		function createRevisionModal () {
			var model = {
				'modalTitle'   : self.hasDraft && 'Edit Draft' || 'Create Revision',
				'modalBodyUrl' : '/templates/templates-new/template-revision/create-revision-message.html',
				'confirmTitle' : 'Continue',
				'identifier'   : 'CreateDraftModal',
				'confirm'      : self.overrideViewMode,
				'cancel'       : angular.noop
			};

			showHideRevisionModal( 'CreateDraftModal', model, self.overrideViewMode );
		}

		function finalizeTemplate ( formIsInvalid ) {
			function confirmHandler () {
				templateView.setViewOnly( true );
				self.close( formIsInvalid, 'templates' );
			}

			var model = {
				'modalTitle'   : 'Finalize Revision',
				'modalBodyUrl' : '/templates/templates-new/template-revision/finalize-revision-message.html',
				'confirmTitle' : 'Finalize Revision',
				'identifier'   : 'FinalizeRevisionModal',
				'confirm'      : confirmHandler
			};

			showHideRevisionModal( 'FinalizeRevisionModal', model, confirmHandler );
		}

		function saveDraft ( formIsInvalid ) {
			function confirmHandler () {
				templateView.setViewOnly( true );
				self.close( formIsInvalid );
			}

			var model = {
				'modalTitle'   : 'Save Draft',
				'modalBodyUrl' : '/templates/templates-new/template-revision/save-draft-message.html',
				'confirmTitle' : 'Save Draft and Close',
				'identifier'   : 'SaveDraftModal',
				'confirm'      : confirmHandler
			};

			showHideRevisionModal( 'SaveDraftModal', model, confirmHandler );
		}

		function previewHandler () {
			var previewType = [ '/preview/draft', '/preview' ];
			var path        = $location.path() + previewType[ Number( self.isViewOnlyMode ) ];

			$location.path( path );
		}

		function isValidTemplateName () {
			var isValidRegExp = new RegExp( '[^ ]' );

			self.isValidTemplate = isValidRegExp.test( self.model.template.name );
			$scope.templateForm.templateName.$setValidity( 'validTemplateName', self.isValidTemplate );

			return self.isValidTemplate;
		}

		function pdOnly ( item ) {
			// making sure that we only count PD in templateAttachments
			return item.hasOwnProperty( 'ContentId' ) || item.fileType === 19;
		}

		function updateSelectedPd ( selectedPd ) {
			selected         = selectedPd;
			self.numberOfPPD = ( selected || [] ).length;

			self.model.templateAttachments = ( selected || [] ).map( templateAttachmentMapper );
		}

		function makePdf ( res ) {
			var template = JSON.parse( angular.toJson( res ) );

			templatePdf.generatePdf( template, self.model.types );
		}

		function errPdf () {
			logger.notifyError( ERROR_MSGS.fetchingData, '' );
		}

		function generatePdf () {
			self.isGenerating = true;
			templateservice.getTemplate( credentials.userId, self.model.templateId, !self.isViewOnlyMode && 'templateDraft' || null )
				.then( makePdf, getFinalizedTemplate( makePdf, errPdf )  )
				.finally( function () {
					self.isGenerating = false;
				} );
		}

		preActivate();

		self.isSaving               = '';
		self.saveTemplate           = saveTemplate;
		self.addGroup               = addGroupHandler;
		self.close                  = closeHandler;
		self.isValidTemplateName    = isValidTemplateName;
		self.updateSelectedPd       = updateSelectedPd;
		self.trimTemplateName       = trimTemplateName;
		self.goBackToList           = goBackToList;
		self.previewHandler         = previewHandler;
		self.pdOnly                 = pdOnly;
		self.generatePdf            = generatePdf;
		self.finalizeTemplate       = finalizeTemplate;
		self.saveDraft              = saveDraft;
		self.overrideViewMode       = overrideViewMode;
		self.createRevisionModal    = createRevisionModal;

		// used for file upload
		self.templateScope     = $scope;
		self.uploadProgress    = {};

		// this is to avoid passing scope to directives
		$rootScope.uploadScope = self.templateScope;

		$scope.$on( 'file:uploading', function ( event, progress ) {
			self.uploadProgress.progress = progress;
		} );
	}

	angular
		.module( 'app.templates' )
		.controller( 'NewTemplates', NewTemplates );

	NewTemplates.$inject = [ '$scope', '$routeParams', 'logger', 'templateservice', '$location', 'collectionService', 'apiService', '$rootScope', 'deepLoadingStatusService', 'TOOLTIP_MESSAGES', 'ERROR_MSGS', 'templateHolder', 'manageShareService', 'authService', 'templatePdf', 'templateRevisionModalService', 'templateView', '$route', 'Session', 'ppdFactory' ];
} )( );
